import { Locale } from "@linkfluence/models/locale";
import DE_DE_TRANSLATION from "../locales/de_DE.json";
import EN_GB_TRANSLATION from "../locales/en_GB.json";
import FR_FR_TRANSLATION from "../locales/fr_FR.json";
import JA_TRANSLATION from "../locales/ja_JP.json";
import ZH_CN_TRANSLATION from "../locales/zh_CN.json";

export default {
  [Locale.English]: EN_GB_TRANSLATION,
  [Locale.French]: FR_FR_TRANSLATION,
  [Locale.Chinese]: ZH_CN_TRANSLATION,
  [Locale.German]: DE_DE_TRANSLATION,
  [Locale.Japanese]: JA_TRANSLATION,
};
